var map = {
	"./edit/edit.module": [
		"./src/app/edit/edit.module.ts",
		"edit-edit-module"
	],
	"./pages/about/about.module": [
		"./src/app/pages/about/about.module.ts",
		"pages-about-about-module"
	],
	"./pages/activitats/activitats.module": [
		"./src/app/pages/activitats/activitats.module.ts",
		"pages-activitats-activitats-module"
	],
	"./pages/serveis/serveis.module": [
		"./src/app/pages/serveis/serveis.module.ts",
		"pages-serveis-serveis-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return __webpack_require__.e(ids[1]).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;